<template>
  <div class="container">
    <home-title
      title="比赛活动"
      link2="/activity"
      :icon="require('@/assets/images/home/home_title/icon7.svg')"
      :newWindow="true"
    ></home-title>
    <div class="act_box dfFw">
      <div
        class="act_item ta3"
        v-for="e in actData"
        :key="e.id"
        @click="goAct(e.ac_url)"
      >
        <div class="act_classify" v-show="e.ac_classification">
          <span>{{ e.ac_classification }}</span>
        </div>
        <img :src="$prefixSrc(e.ac_cover_url)" alt="" class="act_img" />
        <div class="act_info">
          <div class="act_title_box">
            <p class="act_title toh">
              {{ e.ac_name }}
            </p>
            <div :class="`right tag_type${e.status_tag}`">
              {{ tagArr[e.status_tag - 1] }}
            </div>
          </div>

          <div class="act_time">
            <div class="left">
              征集时间：<span style="margin-right: 8px">{{
                e.ac_start_time.split(" ")[0].replace(/-/g, ".") +
                "-" +
                e.ac_end_time.split(" ")[0].replace(/-/g, ".")
              }}</span>
              <span v-if="$leftDay(e.ac_end_time)"
                >距离投稿截止剩<span style="color: #f33">{{
                  $leftDay(e.ac_end_time)
                }}</span
                >天
              </span>
              <span v-else style="color: #666">投稿已截止</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getActivityList } from "@/api/activity";
export default {
  name: "actList",
  components: { homeTitle },
  data() {
    return {
      actData: [],
      tagArr: ["未开始", "进行中", "投票中", "评奖中", "已结束"],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getActivityList({ page: 1, limit: 6 }).then((res) => {
        this.actData = res.data.data;
      });
    },
    goAct(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  .act_box {
    .act_item {
      width: 444px;
      height: 336px;
      background: #fff;
      margin-right: 24px;
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 24px;
      cursor: pointer;
      position: relative;
      &::before {
        content: "";
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 241px;
        background: rgba(51, 51, 51, 0.24);
        top: 0;
        left: 0;
        opacity: 0;
        transition: 0.3s;
      }
      &:hover {
        -moz-transform: translateY(-10px);
        -webkit-transform: translateY(-10px);
        -o-transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        transform: translateY(-10px);
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
        &::before {
          opacity: 1;
        }
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
      .act_classify {
        width: 100px;
        height: 35px;
        border-radius: 10px 0px 10px 0px;
        text-align: center;
        line-height: 35px;
        font-size: 14px;
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
        span {
          z-index: 2;
          position: relative;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(132deg, #21bc9c 0%, #1ada8b 100%);
          opacity: 0.8;
          z-index: 1;
        }
      }
      .act_img {
        width: 100%;
        height: 241px;
        background: #ccc;
      }
      .act_info {
        padding: 16px 20px 0;
        .act_title_box {
          display: flex;
          justify-content: space-between;
          .act_title {
            max-width: 350px;
            font-size: 16px;
            font-weight: 600;
            line-height: 21px;
            color: #333;
            margin-bottom: 10px;
          }
          .right {
            padding-left: 7px;
            width: 66px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            margin-right: -20px;
            font-size: 14px;
            font-weight: 600;
            color: #fff;
            background-size: 100% 100%;
          }
          .tag_type1 {
            background-image: url("@/assets/images/home/act_bg1.png");
          }
          .tag_type2 {
            background-image: url("@/assets/images/home/act_bg2.png");
          }
          .tag_type3 {
            background-image: url("@/assets/images/home/act_bg3.png");
          }
          .tag_type4 {
            background-image: url("@/assets/images/home/act_bg4.png");
          }
          .tag_type5 {
            background-image: url("@/assets/images/home/act_bg5.png");
          }
        }

        .act_time {
          // display: flex;
          // justify-content: space-between;
          // align-items: center;
          margin-top: 4px;
          .left {
            font-size: 12px;
            line-height: 21px;
            color: #999;
            span {
              color: #22b79e;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .act_box {
      .act_item {
        width: 350px;
        height: 275px;
        margin: 0 25px 25px 0;
        &::before {
          height: 190px;
        }
        .act_img {
          height: 190px;
        }
        .act_info {
          padding: 16px 16px 0;
          .act_title_box {
            .act_title {
              max-width: 270px;
            }
          }
          .act_time {
            .right {
              margin-right: -16px;
            }
          }
        }
      }
    }
  }
}
</style>
